import { queryOptions, skipToken } from "@tanstack/react-query";

import { api } from "@/api/api";
import { formatRoomName } from "@/features/hotels/utils/names";
import type { FindHotelOffersOutputDto } from "@/types/codegen";

interface HotelOfferQueryParams {
  hotelId: string;
  searchResultKey: string;
  searchResultToken: string;
}

export const hotelOfferQueryOptions = (params: HotelOfferQueryParams | null) =>
  queryOptions({
    queryKey: ["hotel-offer", params] as const,
    queryFn: params
      ? ({ signal }) =>
          api.get<FindHotelOffersOutputDto>(
            `/hotels/${params.hotelId}/offers`,
            {
              params: {
                searchResultKey: params.searchResultKey,
                searchResultToken: params.searchResultToken,
              },
              signal,
            },
          )
      : skipToken,
    enabled: !!params,
    select: (response) => {
      return response.data.data.map((offer) => ({
        offerId: offer.offerId,
        packageToken: offer.packageToken,
        price: offer.price,
        rooms: offer.rooms.map((room) => ({
          ...room,
          options: room.options.map((option) => ({
            ...option,
            name: formatRoomName(option.name),
            price: option.price ?? offer.price,
            description: option.description?.trim(),
            boardBasis: option.boardBasis?.trim().toUpperCase(),
          })),
        })),
      }));
    },
    throwOnError: false,
  });
